function Copyright() {
  return (
    <div className="copyright-bar">
      <p>Copyright © 2025 財團法人至善社會福利基金會 All rights reserved</p>
    </div>
  );
}

export default Copyright;
